/* ============================================================
   LEVAUX — theme.js
   Cart AJAX, drawer, mobile nav, product page interactions
   ============================================================ */

/* ---- Mobile nav ------------------------------------------ */
const navToggle = document.querySelector('.nav-toggle');
const mobileNav = document.querySelector('.mobile-nav');
if (navToggle && mobileNav) {
  navToggle.addEventListener('click', () => mobileNav.classList.toggle('open'));
}

/* ---- Cart state ------------------------------------------ */
let cartCount = 0;

function formatMoney(cents) {
  return new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: window.Shopify ? window.Shopify.currency.active : 'EUR',
  }).format(cents / 100);
}

function updateCartCount(count) {
  cartCount = count;
  const badge = document.querySelector('.cart-count');
  if (!badge) return;
  badge.textContent = count;
  badge.classList.toggle('visible', count > 0);
}

async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function refreshCartDrawer() {
  const cart = await fetchCart();
  updateCartCount(cart.item_count);
  renderCartItems(cart);
}

function renderCartItems(cart) {
  const container = document.getElementById('cart-drawer__items');
  const footer = document.getElementById('cart-drawer__footer');
  const totalEl = document.getElementById('cart-total-price');
  if (!container) return;

  if (cart.item_count === 0) {
    container.innerHTML = `
      <div class="cart-drawer__empty">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
        </svg>
        <span>Je winkelwagen is leeg</span>
      </div>`;
    if (footer) footer.style.display = 'none';
    return;
  }

  if (footer) footer.style.display = 'block';
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

  container.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item__image">
        ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy">` : ''}
      </div>
      <div class="cart-item__info">
        <div class="cart-item__title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
        <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
        <div class="cart-item__qty">
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-value">${item.quantity}</span>
          <button class="qty-btn" onclick="changeQty('${item.key}', ${item.quantity + 1})">+</button>
          <button class="cart-item__remove" onclick="removeItem('${item.key}')" aria-label="Verwijder">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  `).join('');
}

async function changeQty(key, qty) {
  if (qty < 0) return;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty }),
  });
  refreshCartDrawer();
}

async function removeItem(key) {
  await changeQty(key, 0);
}

/* ---- Cart drawer open/close ------------------------------ */
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeCart();
});

/* ---- Add to cart (product page) -------------------------- */
const addToCartForm = document.getElementById('add-to-cart-form');
if (addToCartForm) {
  addToCartForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = addToCartForm.querySelector('.add-to-cart-btn');
    const variantId = addToCartForm.querySelector('[name="id"]').value;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Toevoegen...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
      });

      if (res.ok) {
        btn.textContent = '✓ Toegevoegd';
        setTimeout(() => {
          btn.textContent = 'Toevoegen aan winkelwagen';
          btn.disabled = false;
        }, 1500);
        openCart();
        refreshCartDrawer();
      } else {
        btn.textContent = 'Niet beschikbaar';
        btn.disabled = false;
      }
    } catch {
      btn.textContent = 'Fout — probeer opnieuw';
      btn.disabled = false;
    }
  });
}

/* ---- Variant selector (product page) --------------------- */
const variantBtns = document.querySelectorAll('.variant-btn');
const variantInput = document.querySelector('[name="id"]');
const priceEl = document.getElementById('product-price');

variantBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    const group = btn.closest('.product-page__variants');
    group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Update hidden input with selected variant id
    if (variantInput) variantInput.value = btn.dataset.variantId;

    // Update price display
    if (priceEl && btn.dataset.price) {
      priceEl.textContent = formatMoney(parseInt(btn.dataset.price));
    }

    // Update add to cart btn availability
    const addBtn = document.querySelector('.add-to-cart-btn');
    if (addBtn) {
      const available = btn.dataset.available === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Toevoegen aan winkelwagen' : 'Uitverkocht';
    }
  });
});

/* ---- Image gallery (product page) ------------------------ */
const thumbBtns = document.querySelectorAll('.product-page__thumb');
const mainImg = document.getElementById('main-product-image');

thumbBtns.forEach(btn => {
  btn.addEventListener('click', () => {
    thumbBtns.forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    if (mainImg) {
      mainImg.src = btn.dataset.src;
      mainImg.alt = btn.dataset.alt || '';
    }
  });
});

/* ---- Init cart count on page load ------------------------ */
fetchCart().then(cart => updateCartCount(cart.item_count));

/* ---- Quick add (collection page) ---- */
async function quickAdd(e, variantId, title) {
  e.preventDefault();
  e.stopPropagation();
  const btn = e.currentTarget || e.target;
  const orig = btn.textContent;
  btn.textContent = '✓ Toegevoegd!';
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    openCart();
    if (typeof refreshCartDrawer === 'function') refreshCartDrawer();
    setTimeout(() => { btn.textContent = orig; }, 2000);
  } catch(err) {
    btn.textContent = orig;
  }
}

/* ---- Hover second image ---- */
document.querySelectorAll('.product-card').forEach(card => {
  const hover = card.querySelector('.product-card__img--hover');
  if (hover) {
    card.addEventListener('mouseenter', () => hover.style.opacity = '1');
    card.addEventListener('mouseleave', () => hover.style.opacity = '0');
  }
});
